import {Component, Input} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {NgClassType} from "../../../model/common.model";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'chatbot-uid-tag',
  standalone: true,
  imports: [
    NgIf,
    RequireClaimsDirective,
    RouterLink,
    NgClass
  ],
  templateUrl: './chatbot-uid-tag.component.html',
})
export class ChatbotUidTagComponent {
  @Input() chatbotUuid?: string
  @Input() ngClass?: NgClassType
  checkFailed = false
}
